// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TriggerIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TriggerIcon" ref={forwardedRef} {...props}>
      <g>
        <path d="m15.758 14.25 4.243-4.249-4.243-4.249-1.06 1.062 3.181 3.187-3.182 3.187z" />
        <path d="M4.243 5.751.001 10l4.242 4.249 1.06-1.062L2.123 10l3.182-3.187z" />
        <path d="M12.125 2.75 5.75 11.207h3.266l-1.14 6.043L14.25 8.8l-3.138-.004z" />
      </g>
      <defs>
        <clipPath id="clip0_2058_3543">
          <rect width="20" height="20" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TriggerIcon = /* @__PURE__ */ Object.assign(TriggerIconComponent, {
  displayName: 'TriggerIcon',
});
